/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import Icon from "../Icon";

const UpRightFromSquareSolidV6 = (props) => (
  <Icon {...props} name="Up Right From Square Solid V6">
    <path d="M12 10a1 1 0 0 0-1 1v3H2V5h3a1 1 0 1 0 0-2H2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-3a1 1 0 0 0-1-1zm3.25-10H11a1.002 1.002 0 0 0-.707 1.707L11.587 3 5.293 9.294a.999.999 0 1 0 1.413 1.413l6.293-6.291 1.293 1.293c.286.286.715.37 1.09.217.373-.157.617-.522.617-.926V.75a.749.749 0 0 0-.75-.75z" />
  </Icon>
);

export default UpRightFromSquareSolidV6;
